import { PropsWithChildren } from "react";
import { PostHogProvider } from "posthog-js/react";
import posthog from "posthog-js";

export const POSTHOG_ALLOWED_HOSTS = ["app.getcrux.ai"];
const POSTHOG_HOST = import.meta.env.VITE_APP_PUBLIC_POSTHOG_HOST as string;
const POSTHOG_KEY = import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY as string;
const isAllowedHost = POSTHOG_ALLOWED_HOSTS.includes(window.location.hostname);

if (isAllowedHost) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,

    // Capture all user interactions
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,

    // Session recording with console logs
    session_recording: {
      recordCrossOriginIframes: true,
      maskAllInputs: true,
      maskInputOptions: {
        password: true,
      },
    },

    // Console logging - CRITICAL for debugging
    enable_recording_console_log: true,

    // Performance monitoring
    capture_performance: true,

    // Persistence
    persistence: "localStorage+cookie",

    // Error tracking - CRITICAL
    capture_dead_clicks: true,

    // KEEP YOUR ORIGINAL CONFIG
    // @ts-expect-error - error_tracking may not be in types but it works
    error_tracking: true,
  });
}

const PostHogProviderWrapper = ({ children }: PropsWithChildren) =>
  !isAllowedHost ? (
    <>{children}</>
  ) : (
    <PostHogProvider client={posthog}>{children}</PostHogProvider>
  );

export default PostHogProviderWrapper;
